import React from "react";
import Header from "./Header";
import TrelloBoard from "./TrelloBoard";

const TrelloTodo = () => {
  return (
    <div>
      <Header />
      <TrelloBoard />
    </div>
  );
};

export default TrelloTodo;
